export interface PhpResponseApiModel<TResult> {
    lists: TResult,
    result: string
}

export class PhpResponseApiModel<TResult> {

}